import HttpRequest from './HttpRequest'

class ProportionStatusAllTypeProvider extends HttpRequest {
  findAll (query) {
    return this.get('/proportion-status-all-types-router/', query)
  }
}

export default ProportionStatusAllTypeProvider
